import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import * as marked from 'marked';

import { OrganizationConfig } from '../../../../../../../../models/organization-config';
import { AccountService } from '../../../../../../../../services/account/account.service';


@Component({
  selector: 'app-gift-card-recipient-text-preview-modal',
  templateUrl: './gift-card-recipient-text-preview-modal.component.html',
  styleUrls: ['./gift-card-recipient-text-preview-modal.component.css']
})
export class GiftCardRecipientTextPreviewModalComponent {
  @Input() orgConfig: OrganizationConfig;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    private domSanitizer: DomSanitizer,
  ) {}

  public getRenderedMarkdown(content: string) {
    return this.domSanitizer.bypassSecurityTrustHtml(
      marked(
        content,
        {
          breaks: true
        }
      )
    );
  }
}
